/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneOptionMultiText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneOptionMultiText({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption/TysiaSelectOneOptionMulti/TysiaSelectOneOptionMultiText",
  size,
  textOverflow,
  order,
  whiteSpace,
  overflowX,
  text = "Default text",
  disabled
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTysiacheckboxtextColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxText.color.primary.base'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 marginLeft={dtSpaceXs}
 color={dtTysiacheckboxtextColorPrimaryBase}
 weight="regular"
 size="xmedium"
 textOverflow={textOverflow}
 order={order}
 whiteSpace={whiteSpace}
 overflowX={overflowX}
 text={text}
 opacity={disabled ? 0.5 : 1}
/>
{children}
</React.Fragment>)
}